import { create } from "zustand";

// 날짜 타입
export type CurDate = {
  year: number | null;
  month: number | null;
};

// 버전 정보 타입
export interface CurScheduleInfo {
  version: number;
  scheduleId: string;
  status: string;
}

// Store
export type ScheduleStore = {
  // State
  curDate: CurDate | null;
  curScheduleInfo: CurScheduleInfo | null; // scheduleId, version 포함
  deletedScheduleIds: Set<string>; // 삭제된 scheduleId 추적

  // Actions
  setCurDate: (date: CurDate) => void;
  setCurScheduleInfo: (info: CurScheduleInfo | null) => void;
  setScheduleId: (id: string) => void;
  setCurVersion: (version: number) => void; // string -> number로 수정 권장
  addDeletedScheduleId: (id: string) => void;
  removeDeletedScheduleId: (id: string) => void;
};

export const useScheduleStore = create<ScheduleStore>((set) => ({
  curDate: null,
  curScheduleInfo: null,
  deletedScheduleIds: new Set<string>(),

  // 날짜만 세팅
  setCurDate: (date) => set({ curDate: date }),

  // 스케줄 세팅
  setCurScheduleInfo: (info) => set({ curScheduleInfo: info }),

  // 버전만 부분 업데이트
  setCurVersion: (version) =>
    set((state) => ({
      curScheduleInfo: state.curScheduleInfo
        ? { ...state.curScheduleInfo, version }
        : null,
    })),

  // Schdule ID만 부분 업데이트
  setScheduleId: (id) =>
    set((state) => ({
      curScheduleInfo: state.curScheduleInfo
        ? { ...state.curScheduleInfo, scheduleId: id }
        : null,
    })),

  // 삭제된 scheduleId 추가
  addDeletedScheduleId: (id) =>
    set((state) => {
      const newSet = new Set(state.deletedScheduleIds);
      newSet.add(id);
      return { deletedScheduleIds: newSet };
    }),

  // 삭제된 scheduleId 제거 (버전 리스트에 다시 나타난 경우)
  removeDeletedScheduleId: (id) =>
    set((state) => {
      const newSet = new Set(state.deletedScheduleIds);
      newSet.delete(id);
      return { deletedScheduleIds: newSet };
    }),
}));
